import { useQuery } from '@provision/graphql-client';
import { CgCustomDomainStatus } from '@provision/landing-page-utils';
import { useEffect } from 'react';
import { isNullish } from 'remeda';
import { GET_CG_CUSTOM_DOMAINS_QUERY } from 'src/graphql/entities/cg-custom-domain/cg-custom-domain.operations';
import {
  type CgCustomDomain,
  type GetCgCustomDomainsQueryData,
} from 'src/graphql/entities/cg-custom-domain/cg-custom-domain.types';

// The check job runs every 3 minutes; polling keeps the cards moving without a click.
const PENDING_POLL_MS = 30_000;

const PENDING_STATUSES = [
  CgCustomDomainStatus.PendingValidation,
  CgCustomDomainStatus.Validated,
];

const NO_DOMAINS: CgCustomDomain[] = [];

export const useCgCustomDomains = (partnerId: number | null) => {
  const { data, loading, startPolling, stopPolling } = useQuery<GetCgCustomDomainsQueryData>(
    GET_CG_CUSTOM_DOMAINS_QUERY,
    {
      skip: isNullish(partnerId),
      variables: { input: { partnerId: partnerId ?? 0 } },
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
      context: { ttl: 0 },
    },
  );

  const domains = data?.getCgCustomDomains ?? NO_DOMAINS;
  const isAnyPending = domains.some((domain) => PENDING_STATUSES.includes(domain.status));

  useEffect(() => {
    if (!isAnyPending) return;

    startPolling(PENDING_POLL_MS);

    return stopPolling;
  }, [isAnyPending, startPolling, stopPolling]);

  return { domains, loading };
};
